import { useEffect } from "react";

type Props = { gtmSrc: string; env?: string };

export default function GtmLoader({ gtmSrc, env = "production" }: Props) {
  useEffect(() => {
    if (!gtmSrc || document.getElementById("gtm-js")) return;

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      environment: env,
      "gtm.start": Date.now(),
      event: "gtm.js",
    });

    const s = document.createElement("script");
    s.async = true;
    s.id = "gtm-js";
    s.src = gtmSrc;
    document.head.appendChild(s);
  }, [gtmSrc, env]);

  return (
    <noscript>
      <iframe
        src={gtmSrc.replace("gtm.js", "ns.html")}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
      />
    </noscript>
  );
}
